/**
 * Call nested global function
 * @param {string} funcName - Nested func Name
 */
export const callNestedFunc = (funcName) => {
  const nestedFunction = getNestedFunctionContext(funcName);
  if (nestedFunction) {
    nestedFunction.ctx[nestedFunction.finalFunc]();
  }
};

/**
 * Check the global nested function
 * @param {string} funcName - Nested func Name
 */
export const getNestedFunctionContext = (funcName) => {
  if (!funcName) {
    return null;
  }
  let allObjs = funcName.split('.');
  let finalFunc = allObjs.pop();

  let ctx = window;
  const validFuncName = allObjs.every((o) => {
    ctx = ctx[o];
    return typeof ctx === 'object' || typeof ctx === 'function';
  });

  if (!validFuncName && typeof ctx[finalFunc] !== 'function') {
    return null;
  }
  return { ctx, finalFunc };
};

/**
 * Call login function
 * @param {string} funcName - login func Name
 */
export const callLoginMethod = (funcName) => {
  const nestedFunction = getNestedFunctionContext(funcName);
  if (nestedFunction) {
    if (APP_SETTINGS.settings.externalLoginMethodParams) {
      const param = JSON.parse(APP_SETTINGS.settings.externalLoginMethodParams);
      nestedFunction.ctx[nestedFunction.finalFunc](param);
      return;
    }
    nestedFunction.ctx[nestedFunction.finalFunc]();
  }
};

/**
 * Genreal script for fetching resources
 * @param {'script'|'link'} tagName - Element tag name
 * @param {string} elementId - Element unique Id
 * @param {{async?: boolean, src?: string, rel?: 'stylesheet', href?: string}} options - Options object
 */
export const fetchResource = (tagName = 'script', elementId = 'bto-mb-lmt', options) => new Promise((resolve, reject) => {
  if (document.getElementById(elementId)) {
    resolve();
    return;
  }

  let el = document.createElement(tagName);
  Object.entries(options).forEach(([key, val]) => {
    el.setAttribute(key, val);
  });
  el.id = elementId;

  el.onload = resolve;
  el.onerror = reject;

  document.head.appendChild(el);
});

/**
 * Debounce function
 * @param {Function} func - callback function
 * @param {number} timeout - timeout in milisecons
 */
export const debounce = (func, timeout = 300) => {
  let timer;
  function debounced(...args) {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  }
  function cancel() {
    clearTimeout(timer);
    timer = undefined;
  }
  debounced.cancel = cancel;
  return debounced;
}

/**
 * Throttle function
 * @param {Function} func - callback function
 * @param {number} timeout - timeout in milisecons
 */
export const throttle = (func, timeout = 300) => {
  let throttlePause;
  let timer;

  function throttled(...args) {
    if (throttlePause) {
      return;
    }
    throttlePause = true;

    timer = setTimeout(() => {
      throttlePause = false;
      func.apply(this, args);
    }, timeout);
  }

  function cancel() {
    clearTimeout(timer);
    timer = undefined;
    throttlePause = undefined;
  }
  throttle.cancel = cancel;

  return throttled;
}